<script setup lang="ts">
import { dayjs } from 'element-plus'
import { Lock, CircleCheck } from '@element-plus/icons-vue'
import { socketEmit, socketEmitAsync } from '@/utils/web-socket'
import { useCommonStore } from '@/stores/modules/common'
import { computed } from 'vue'
import type { PetType } from '@/types/pet'
import { getPetName } from '@/views/pet-ranch/data'
import PetInfo from '@/views/pet-ranch/components/PetInfo.vue'
import type { CheckInType } from '@/types/check-in'
import { reactive } from 'vue'
import { onMounted } from 'vue'

const commonStore = useCommonStore()

const emits = defineEmits(['close'])

const day3PetInfo: PetType = {
  id: 'activity',
  quality: 'legend',
  monsterId: 1004,
  fightAttrs: {
    atk: 3,
    atksp: 5,
    heat: 3,
  },
  outsideAttrs: {
    gold: 88888,
  },
  isLock: false,
}

const checkInRewardList = [
  { text: '💎 2000' },
  { text: '💎 2000', petInfo: day3PetInfo },
  { text: '💎 2000' },
  { text: '💎 2000' },
  { text: '💎 2000' },
  { text: '💎 2000' },
  { text: '💎 2000' },
  { text: '💎 2000' },
  { text: '💎 2000' },
  { text: '💎 2000' },
]

const canReceive = computed(() => !checkInInfo.date || dayjs().diff(dayjs(checkInInfo.date), 'day') >= 1)
const isOver = computed(() => checkInInfo.count === checkInRewardList.length)

function checkIsLock(index: number) {
  if (index === 0) return false
  const isTodayCheck = dayjs().diff(dayjs(checkInInfo.date || undefined), 'day') >= 1
  if (isTodayCheck) {
    return index > checkInInfo.count
  } else {
    return index >= checkInInfo.count
  }
}

const checkInInfo = reactive({
  date: '',
  count: 0,
})
async function getCheckInInfo() {
  socketEmit<CheckInType>({
    type: 'getActivityCheckInInfo',
    callBack: (res) => {
      if (!res.data) {
        checkInInfo.date = '1970-01-01 00:00:00'
        checkInInfo.count = 0
        commonStore.canCheckIn = true
        return
      }
      checkInInfo.date = res.data.date
      checkInInfo.count = res.data.count
      if (checkInInfo.count < checkInRewardList.length) commonStore.canCheckIn = canReceive.value && !isOver.value
    },
  })
}
async function handleReceive() {
  await socketEmitAsync({ type: 'receiveActivityCheckIn' })
  checkInInfo.date = dayjs().format('YYYY-MM-DD 00:00:00')
  if (!checkInInfo.count) {
    checkInInfo.count = 1
  } else {
    checkInInfo.count++
  }
  commonStore.canCheckIn = true
  commonStore.getMailList()
}

onMounted(() => {
  if (!commonStore.isSocketInit) return
  getCheckInInfo()
})
</script>

<template>
  <div class="novice-check-in">
    <div class="reward">
      <div class="border-wrap" v-for="(item, index) of checkInRewardList" :key="index">
        <h3>第 {{ index + 1 }} 日</h3>
        <template v-if="item.text">
          <span class="affix" v-html="item.text"></span>
        </template>
        <template v-if="item.petInfo">
          <el-popover placement="bottom" width="300px" trigger="click" :teleported="false">
            <template #reference>
              <CommonBtn size="small" class="no-back" style="margin-top: 5px">
                <span :class="item.petInfo.quality">{{ getPetName(item.petInfo.monsterId) }}</span>
              </CommonBtn>
            </template>
            <PetInfo :pet-info="item.petInfo" :show-action="false" />
          </el-popover>
        </template>
        <div class="lock overlay" v-show="checkIsLock(index)">
          <el-icon><Lock /></el-icon>
        </div>
        <div class="check overlay" v-show="checkInInfo.count > index">
          <el-icon><CircleCheck /></el-icon>
        </div>
      </div>
    </div>
    <p>* 2026-03-08 活动结束</p>
    <el-button type="success" plain style="width: 100%" @click="handleReceive" :disabled="!canReceive">
      {{ canReceive ? '签到并领取' : isOver ? '已全部领取' : '静候时日' }}
    </el-button>
  </div>
</template>

<style lang="scss" scoped>
.novice-check-in {
  .reward {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    .border-wrap {
      width: calc(33.33% - 5px);
      padding: 10px;
      margin-bottom: 10px;
      position: relative;
      h3 {
        font-size: 16px;
        text-align: left;
        margin: 0 0 10px 0;
      }
      .common-btn-wrap {
        text-align: left;
        width: 100%;
        :deep(button) {
          width: 100%;
        }
      }
      .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba($color: #fff, $alpha: 0.1);
        pointer-events: none;
        i {
          font-size: 20px;
        }
        &.lock {
          i {
            color: #f05654;
          }
        }
        &.check {
          i {
            color: #3eb370;
          }
        }
      }
    }
  }
}
</style>
